import { gql } from "@apollo/client";

export default gql`
query GetUsers($survey_language: String, $trial_type: String, $survey_type: String) {
  users(trial_type: $trial_type, survey_language:$survey_language, survey_type: $survey_type) {
    id
    user_name
    section_1_completed_date
    surveys {
      id
      title
      completed_date
      section_2_completed_date
      section_3_completed_date
    }
  }
}
`